// extracted by mini-css-extract-plugin
export default {"btnArea":"timedialog_btnArea__o0r3N","content":"timedialog_content__9toVU","close":"timedialog_close__bfVLn"};